import { makeStyles } from '@material-ui/core';
import icon from '../../assets/logos/footballco-icon-white.svg';

const useStyles = makeStyles({
  img: {
    width: 'auto',
    height: 28,
  },
});

export const LogoIcon = () => {
  const classes = useStyles();

  return <img className={classes.img} src={icon} alt="Footballco" />;
};
